import { useMemo } from 'react';

export const getEnvList = (envVarName, separator = ',', defaultValue = []) => {
  const envValue = process.env[envVarName];
  if (!envValue || typeof envValue !== 'string') {
    return defaultValue;
  }
  const parsed = envValue
    .split(separator)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
  return parsed.length > 0 ? parsed : defaultValue;
};

const useEnvList = (envVarName, separator = ',', defaultValue = []) => useMemo(() => getEnvList(
  envVarName,
  separator,
  defaultValue,
), [envVarName, separator, defaultValue]);

export default useEnvList;
